import React, { useEffect, useState } from "react";
import "../../style/index.scss";
import { DropDown } from "../../../commons";
import { Label } from "reactstrap";
import ReactDatePicker from "react-datepicker";
import { CalenderIcon } from "../../../Icon";
import moment from "moment";
import {
  CREATE_JOB_ON,
  REPEAT_JOB_OPTIONS,
  WAIT_POST_PERIOD_END_DATE,
  WAIT_POST_PERIOD_START_DATE,
  WAIT_POST_PERIOD_START_DATE_START_OF_PERIOD,
  periodOption,
} from "../../../../constant/jobs";

export const PERIOD_OPTIONS = periodOption();

export const selectStyle = {
  option: (baseStyles: any, state: any) => ({
    ...baseStyles,
    whiteSpace: "wrap",
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "#fff",
    boxShadow: "none",
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    ...provided,
    padding: "0px",
    display: "none",
  }),
};

type AppProps = {
  jobData: any;
  jobsError: any;
  type?: string;
  handleChange: (data: any, name: string) => void;
};

const RecurringJobSetting = ({
  jobData,
  handleChange,
  jobsError,
  type,
}: AppProps) => {
  const [isPeriodEndedChanged, setIsPeriodEndedChanged] =
    useState<boolean>(false);

  useEffect(() => {
    if (
      jobData?.repeat?.value &&
      jobData?.periodLength?.value &&
      jobData?.nextPeriodEnd &&
      jobData?.jobCreatedOn?.value &&
      (type != "editJob" || (type === "editJob" && isPeriodEndedChanged))
    ) {
      let jobDate = jobData?.nextPeriodEnd;

      let formattedDate = jobDate.split("-").reverse().join("-");

      let newDate = new Date(formattedDate);

      const now = moment(newDate);

      if (jobData?.jobCreatedOn?.value === "End of Period") {
        now.add(1, "days");
        let finalDate = moment(now.format()).format("DD-MM-YYYY");
        handleChange(finalDate, "nextJob");
      } else if (jobData?.jobCreatedOn?.value === "Start of Period") {
        if (jobData?.repeat?.value === "Yearly") {
          now.subtract(+jobData?.periodLength?.value, "years");
        } else if (jobData?.repeat?.value === "Weekly") {
          now.subtract(+jobData?.periodLength?.value * 7, "days");
        } else if (jobData?.repeat?.value === "Monthly") {
          now.subtract(+jobData?.periodLength?.value, "months");
        } else if (jobData?.repeat?.value === "Daily") {
          now.subtract(+jobData?.periodLength?.value, "days");
        }

        let finalDate = moment(now.format()).format("DD-MM-YYYY");
        handleChange(finalDate, "nextJob");
      }
    }
  }, [
    jobData?.repeat?.value,
    jobData?.jobCreatedOn?.value,
    jobData?.nextPeriodEnd,
    jobData?.periodLength?.value,
    isPeriodEndedChanged,
  ]);

  return (
    <div className="recurring-job">
      <div className="recurring-job-setting mt-1">RECURRING JOB SETTINGS</div>
      <div className="row mt-2">
        <div className="col-md-3">
          <label>Repeat</label>
          <div className="mt-1">
            <DropDown
              options={REPEAT_JOB_OPTIONS}
              value={jobData?.repeat}
              handleChange={(e) => handleChange(e, "repeat")}
              style={selectStyle}
            />
          </div>
          <div>
            {!!jobsError?.repeat && (
              <small className="text-danger">{jobsError?.repeat}</small>
            )}
          </div>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-md-2">
          <label>Period Length</label>
          <div className="mt-1">
            <DropDown
              options={PERIOD_OPTIONS}
              value={jobData?.periodLength}
              handleChange={(e) => handleChange(e, "periodLength")}
              style={selectStyle}
            />
          </div>
          <div>
            {!!jobsError?.periodLength && (
              <small className="text-danger">{jobsError?.periodLength}</small>
            )}
          </div>
        </div>

        <div
          className="col-md-1.5 recurring-word"
          style={{ paddingRight: "0.3rem" }}
        >
          {jobData?.repeat?.value === "Monthly"
            ? "Month"
            : jobData?.repeat?.value === "Yearly"
            ? "Year"
            : jobData?.repeat?.value === "Weekly"
            ? "Weeks"
            : "Days"}{" "}
          until
        </div>

        <div className="col-md-2">
          <label>Next Period End</label>
          <div className="d-flex flex-row position-relative mt-1">
            <div className="date-picker-wraper mr-0 w-100">
              <Label className="m-0 p-0 w-100">
                <ReactDatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    jobData?.nextPeriodEnd
                      ? new Date(
                          moment(
                            `${jobData?.nextPeriodEnd}T00:00:00`,
                            "DD-MM-YYYY"
                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                        )
                      : null
                  }
                  onChange={(e: any) => {
                    handleChange(
                      e ? moment(e).format("DD-MM-YYYY") : null,
                      "nextPeriodEnd"
                    );
                    setIsPeriodEndedChanged(true);
                  }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name="NextPeriodEnd"
                  placeholderText="Choose Date"
                  className="form-control pointer"
                />
                <span
                  className="calender-icon"
                  style={{ right: "5px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
          <div>
            {!!jobsError?.nextPeriodEnd && (
              <small className="text-danger">{jobsError?.nextPeriodEnd}</small>
            )}
          </div>
        </div>

        <div
          className="col-md-1.5 recurring-word"
          style={{ paddingRight: "0.3rem" }}
        >
          then Create Job
        </div>

        <div className="col-md-2" style={{ paddingRight: "0.3rem" }}>
          <label>Create Job On</label>
          <div className="mt-1">
            <DropDown
              options={CREATE_JOB_ON}
              value={jobData?.jobCreatedOn}
              handleChange={(e) => handleChange(e, "jobCreatedOn")}
              style={selectStyle}
            />
          </div>
          <div>
            {!!jobsError?.jobCreatedOn && (
              <small className="text-danger">{jobsError?.jobCreatedOn}</small>
            )}
          </div>
        </div>

        <div
          className="col-md-1.5 recurring-word"
          style={{ paddingRight: "0.4rem", paddingLeft: "0.4rem" }}
        >
          Next Job Starts on
        </div>
        <div
          className={`col-md-1.5 next-job ${
            jobData?.jobCreatedOn?.value == "Start of Period" ? "red" : "purple"
          }`}
          style={{
            marginTop: "1.6rem",
            padding: "10px 22px 10px 22px",
            marginLeft: "0rem",
            marginBottom: "1rem",
          }}
        >
          {jobData?.nextJob}
        </div>
      </div>

      <div className="row mt-2 mb-2">
        <div className="col-md-4 recurring-word"> FOR NEXT JOB</div>
      </div>

      <div className="row mt-2">
        <div className="col-md-2 ">
          <label>Target Start Date</label>
          <div className="mt-1">
            <DropDown
              options={PERIOD_OPTIONS}
              value={jobData?.targetStartDate}
              handleChange={(e) => handleChange(e, "targetStartDate")}
              style={selectStyle}
            />
          </div>
          <div>
            {!!jobsError?.targetStartDate && (
              <small className="text-danger">
                {jobsError?.targetStartDate}
              </small>
            )}
          </div>
        </div>

        <div className="col-md-3">
          <label></label>
          <div className="mt-2">
            <DropDown
              options={
                jobData?.jobCreatedOn?.value != "Start Of Period"
                  ? WAIT_POST_PERIOD_START_DATE
                  : WAIT_POST_PERIOD_START_DATE_START_OF_PERIOD
              }
              value={jobData?.WaitPostPeriodStartDate}
              handleChange={(e) => handleChange(e, "WaitPostPeriodStartDate")}
              style={selectStyle}
            />
          </div>
          <div>
            {!!jobsError?.WaitPostPeriodStartDate && (
              <small className="text-danger">
                {jobsError?.WaitPostPeriodStartDate}
              </small>
            )}
          </div>
        </div>

        <div className="col-md-1"></div>

        <div className="col-md-2">
          <label>
            Target End Date <span className="color-red">*</span>{" "}
          </label>
          <div className="mt-1">
            <DropDown
              options={PERIOD_OPTIONS}
              value={jobData?.targetEndDate}
              handleChange={(e) => handleChange(e, "targetEndDate")}
              style={selectStyle}
            />
          </div>
          <div>
            {!!jobsError?.targetEndDate && (
              <small className="text-danger">{jobsError?.targetEndDate}</small>
            )}
          </div>
        </div>

        <div className="col-md-3">
          <label></label>
          <div className="mt-2">
            <DropDown
              options={WAIT_POST_PERIOD_END_DATE}
              value={jobData?.WaitPostPeriodEndDate}
              handleChange={(e) => handleChange(e, "WaitPostPeriodEndDate")}
              style={selectStyle}
            />
          </div>
          <div>
            {!!jobsError?.WaitPostPeriodEndDate && (
              <small className="text-danger">
                {jobsError?.WaitPostPeriodEndDate}
              </small>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecurringJobSetting;
